import { createContext, useContext } from "react";

export function createTypedContext<T>() {
  const Context = createContext<T | undefined>(undefined);
  const useTypedContext = () => {
    const value = useContext(Context);
    if (value === undefined) throw new Error("Context not provided");
    return value;
  };
  return [Context.Provider, useTypedContext] as const;
}


